import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { H1, H4, H3 } from "../../styles/typography/typography.js";
import { colors } from "../../styles/variables.js"
import Svg from "../../assets/icons/icons";

import { addToFavorites, deleteFromFavorites } from '../../store/favorites/actions';

import {
  WrapStyled,
  LineStyled,
  LineLeftStyled,
  LineRighttyled,
  TooltipWrapStyled,
  TextWrapStyled,
  TextContentStyled,
  MoreContentStyled,
  SmallDescription,
  WrapForMobilefavorites
} from './style.js';

import {
  SpanStyled
} from '../Tabs-header/style.js';

import {
  UlSt
} from '../Select/style.js';

import {
  IconWrapFavoritesSt
} from '../Tabs-left/style.js';


import TabsHeader from "../Tabs-header/Tabs-header";
import TabsCardEvents from "../TabsCardEvents/TabsCardEvents";
import i18n from "i18next";

const TabsDescription = ({
  manager, location, name, genre, description, header, bigDescription, smallDescription,
  moreDetails, is_format, channel, numberSeasons, numberEpisodes, channelLogo,
  seasonsDes, id, typeBookmark, isInFavourites,
}) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [moreIsOpen, setMoreIsOpen] = useState(false);
  const [bookmarkFavorites, setBookmarkFavorites] = useState(false);
  const [bookmarkCheck, setBookmarkCheck] = useState("not");

  const dispatch = useDispatch();
  const token = useSelector((store) => store.auth.dataToken.token);

  const _handleTooltipClick = (evt) => {
    evt.preventDefault();
    setTooltipIsOpen((prev) => !prev);
  };

  const _handleMoreClick = (evt) => {
    evt.preventDefault();
    setMoreIsOpen((prev) => !prev);
  };

  // componentDidUpdate: закрытие тултипа по клику снаружи
  useEffect(() => {
    if (!tooltipIsOpen) return undefined;

    const tooltipeOutside = () => { setTooltipIsOpen(false) };
    document.addEventListener('click', tooltipeOutside);
    return () => { document.removeEventListener('click', tooltipeOutside) };
  }, [tooltipIsOpen]);

  // обработка клика на закладку
  const _bookmark = (ids, type) => {
    if (bookmarkCheck === "not") {
      // при первом клике отталкиваемся от значения, пришедшего с сервера
      const current = isInFavourites;
      if (current) {
        dispatch(deleteFromFavorites(ids, type, token));
      } else {
        dispatch(addToFavorites(ids, type, token));
      }
      setBookmarkFavorites(!current);
      setBookmarkCheck("check");
    }
    else if (bookmarkCheck === "check") {
      if (bookmarkFavorites) {
        dispatch(deleteFromFavorites(ids, type, token));
      } else {
        dispatch(addToFavorites(ids, type, token));
      }
      setBookmarkFavorites((prev) => !prev);
    }
  };

  const favorietsColor = bookmarkCheck === "check" ? bookmarkFavorites : isInFavourites

  //Формирование попапа с колличеством сезонов и качеством
  const newEpisodesPopup = numberSeasons && numberSeasons.map((item, i) => {
    return (<React.Fragment key={i}>
      <b>{i + 1} {i18n.t(`catalog.project.${0}.season`)}{seasonsDes[i].status_text && (", " + seasonsDes[i].status_text)}:</b><br />
      {numberEpisodes.length > 0 && <>{numberEpisodes[i] ? numberEpisodes[i] : 0} {i18n.t(`catalog.project.${0}.season_episodes`)} <b>х</b> {description[1].text}<br /></>}
    </React.Fragment>)
  })

  return (
    <>
      {(window.innerWidth > 767 && header)
        ? <TabsHeader name={name} genre={genre} is_format={is_format} channel={channel} channelLogo={channelLogo} />
        : <WrapForMobilefavorites>
          <H1>{name}</H1>
          <IconWrapFavoritesSt onClick={() => _bookmark([id], typeBookmark)}>
            <Svg width="24" height="24" type={favorietsColor ? "bookmark" : "bookmark_border"} color={colors.blue_active} fill="white"></Svg>
          </IconWrapFavoritesSt>
        </WrapForMobilefavorites>

      }

      {smallDescription && <SmallDescription><H4>{smallDescription}</H4></SmallDescription>}
      <WrapStyled>
        {
          description.map((item, index) =>

            (item.name === "Количество сезонов" || item.name === "Seasons") && numberSeasons.length > 1
              ? (item.text > 0 && <LineStyled key={index}>
                <LineLeftStyled>{item.name}</LineLeftStyled>
                <LineRighttyled onClick={_handleTooltipClick}>
                  <a href="#">{item.text}</a>
                  {(tooltipIsOpen) &&
                    <TooltipWrapStyled>
                      <UlSt>
                        <SpanStyled>
                          {newEpisodesPopup}
                        </SpanStyled>
                      </UlSt>
                    </TooltipWrapStyled>
                  }
                </LineRighttyled>
              </LineStyled>)
              : ((item.text.length < 1 || item.text < 1 || item.text === "... - ...") ? "" : <LineStyled key={index}>
                <LineLeftStyled>{item.name}</LineLeftStyled>
                {/* <LineRighttyled>{item.text}</LineRighttyled>*/}
                <LineRighttyled dangerouslySetInnerHTML={{ __html: `${item.text}` }}></LineRighttyled>
              </LineStyled>)
          )
        }

      </WrapStyled>
      {bigDescription &&
        <TextWrapStyled>
          <TextContentStyled dangerouslySetInnerHTML={{ __html: `${bigDescription}` }}></TextContentStyled>
          {(moreIsOpen || !bigDescription) &&
            <TextContentStyled>{" " + moreDetails}</TextContentStyled>}
          {(moreDetails && bigDescription) &&
            <MoreContentStyled onClick={_handleMoreClick}>{(!moreIsOpen) ? i18n.t(`event.detail`) : i18n.t(`event.turn`)}</MoreContentStyled>}
        </TextWrapStyled>
      }
      {manager &&
        <>
          <TextWrapStyled>
            <H3>{i18n.t(`event.managers_at_this_event`)}</H3>
            <TabsCardEvents manager={manager} location={location} />
          </TextWrapStyled>
        </>
      }
    </>
  );
};

export default TabsDescription;
